// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CZnBq","body":"styles_body__NKRbX","blueline":"styles_blueline__myk2T","addButton":"styles_addButton__PCFmi","noRecords":"styles_noRecords__VJSpU"};